export default "__VITE_ASSET__ChkPN1RM__"